import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { reduceres } from "../reducers";

const middleware = [thunk];

export const store = createStore(
  reduceres,
  undefined,
  compose(applyMiddleware(...middleware)),
);



// WEBPACK FOOTER //
// ./frontend/redux/store/store.js